import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpRequestService } from 'src/app/core/services';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-details-answer-sheet',
  templateUrl: './details-answer-sheet.component.html',
  styleUrls: ['./details-answer-sheet.component.scss'],
})
export class DetailsAnswerSheetComponent implements OnInit {
  answerSheet: any = null;
  loading = false;

  sectionLoadingMap: { [key: number]: boolean } = {};

  // stats
  totalQuestions = 0;
  correctCount = 0;
  incorrectCount = 0;
  markedForReviewCount = 0;
  unseenCount = 0; // ✅ NEW
  totalMarksObtained = 0;
  totalMarksPossible = 0;

  constructor(
    private route: ActivatedRoute,
    private httpRequestService: HttpRequestService,
    private notification: NzNotificationService,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) this.getAnswerSheet(id);
  }

  getAnswerSheet(id: string): void {
    this.loading = true;
    this.httpRequestService
      .request('get', `answer-sheets/get/${id}`, {})
      .subscribe(
        (res: any) => {
          this.answerSheet = res.data || res;
          this.loading = false;

          this.answerSheet.section?.forEach((_: any, i: number) => {
            this.sectionLoadingMap[i] = true;
          });

          this.answerSheet.section?.forEach((_: any, i: number) => {
            setTimeout(() => {
              this.sectionLoadingMap[i] = false;
            }, i * 150);
          });

          setTimeout(() => {
            this.computeStats();
          }, 0);
        },
        (err: any) => {
          this.loading = false;
          this.notification.error('Error', 'Failed to load answer sheet');
          console.error(err);
        },
      );
  }

  computeStats(): void {
    this.totalQuestions = 0;
    this.correctCount = 0;
    this.incorrectCount = 0;
    this.markedForReviewCount = 0;
    this.unseenCount = 0; // ✅ reset
    this.totalMarksObtained = 0;
    this.totalMarksPossible = 0;

    if (!this.answerSheet?.section) return;

    for (const sec of this.answerSheet.section) {
      if (!sec.questions) continue;
      this.totalQuestions += sec.questions.length;

      for (const q of sec.questions) {
        // ✅ Key fix: check if an answer was actually given
        const hasAnswer =
          q.answerText !== null &&
          q.answerText !== undefined &&
          q.answerText !== '';

        if (q.isCorrect) {
          this.correctCount++;
        } else if (!hasAnswer) {
          this.unseenCount++; // no answer → Not Visited
        } else {
          this.incorrectCount++; // answered but wrong → Incorrect
        }

        if (q.isMarkedForReview) this.markedForReviewCount++;
        this.totalMarksObtained += q.marksObtained || 0;
        this.totalMarksPossible += q.marks || 0;
      }
    }
  }

  formatTime(minutes: number): string {
    if (!minutes) return '0m';
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h > 0 && m > 0) return `${h}h ${m}m`;
    if (h > 0) return `${h}h`;
    return `${m}m`;
  }
}
